import React, { useEffect, useState } from 'react'
import styles from './pagoSpei.module.sass'

import { useHistory } from 'react-router-dom'
import CurrencyFormat from "react-currency-format"
import { CopyToClipboard } from 'react-copy-to-clipboard'

import { usePaySpei } from 'hooks/usePayCard'
import { useValUserT1 } from 'hooks/useValUserT1'

import { decodeStorage, encodeStorage } from 'functions/storageBase64'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

import { ModalError } from 'components/Error/ErrorModal'


export function BtnPagoSpei (props) {
    const {
        loading
    } = props
    
    const history = useHistory();
    const { 
        tokenT1Card,
        errorT 
    } = useValUserT1({timeRef: 1000});
    const {
        dataPayment,
        successPay,
        errorPay
    } = usePaySpei()
    
    
    const payCardRelation = decodeStorage('payCardRelation')

    const [errorCode, setErrorCode] = useState()
    const [messageResponse, setMessageResponse] = useState()
    const [sectionActive, setSectionActive] = useState(null)
    const [showModalErr, setShowModalErr] = useState(false);

    const[btnClickSpei, setBtnClickSpei] = useState(false)
    const clickSpei=()=>{
        setBtnClickSpei(true)
        loading(true)
    }
    
    useEffect(()=>{
        if(btnClickSpei){
            if(tokenT1Card){
                dataPayment({
                    userId: tokenT1Card,
                    payCardRelation: payCardRelation
                })
            }
            setBtnClickSpei(false)
        }
    },[btnClickSpei])


    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'choiseCards') {
            //history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar/elegir-tarjeta`)
        }
    }

    useEffect(()=>{
        if(successPay){
            loading(false)
            encodeStorage('payCodeSuccess', successPay)
            history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/thankYouPage-spei`);
        }
        else if(errorPay){
            loading(false)
            setShowModalErr(true)
            setErrorCode(errorPay)
            setSectionActive('choiseCards')
            setMessageResponse(errorPay?.message || errorPay?.error)
        }
    },[successPay, errorPay])

    return(
        <>
            <li className='spei' onClick={clickSpei}>CLABE Interbancaria <div className="smallText">Desde la APP o Banca en línea de tu banco.</div></li>
            {showModalErr &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }
        </>
    )
}

export function ThanskPageSpei (props) {
    const {
        payCard,
        clabe,
        payCode,
        isMobile
    } = props

    const [, setcopied] = useState(false);
    const onCopy = () => { setcopied(true); }
    const [click, setclick] = useState(false);
    const handleClickCopy = () => {
        setclick(!click);
    }

    // useEffect(() => {
    //     console.log('---------------------')
    //     console.log('clabe: ', clabe)
    //     console.log('payCard: ', payCard)
    //     console.log('payCode: ', payCode)
    // }, [])

    return(
        <div className={styles?.contArrayCards}>
            <div className={styles?.formasPagoTienda} id="no-imprimir">

                <div className={styles?.titleSection}>
                    {isMobile === 'desktop'
                        ?
                            <img src="/credito-claroshop/img/newCredito/logo-claroshop.svg" alt="logoCS" width="250" height="100" />
                        : null
                    }
                    <p className={`${styles?.textTPSpei}`}>Pago con SPEI</p>
                </div>

                <div className={styles?.cardSection}>
                    <p className={styles?.textClave}>CLABE interbancaria</p>
                    <CopyToClipboard text={clabe} onCopy={() => setcopied(true)}>
                        <strong className={styles?.clave}> {clabe}</strong>
                    </CopyToClipboard>
                    <CopyToClipboard text={clabe} onCopy={() => onCopy()}>
                        <span onClick={handleClickCopy} className={`${styles?.botonCopy} btn rojo`}>Copiar CLABE</span>
                    </CopyToClipboard>

                </div>


                <div className={`${styles?.cardSpeiData} ${styles?.cardSection}`}>
                    <dl>
                        <dt><span className={styles?.numOption}>1</span> Selecciona la opción transferencia y pega tu CLABE.</dt>
                    </dl>
                    <dl>
                        <dt>
                            <span className={styles?.numOption}>2</span> 
                            <p>
                                Ingresa el monto a pagar:
                                {payCard &&
                                    <CurrencyFormat
                                        value={Number(payCard.totalToPay % 1) === 0 ? payCard.totalToPay + '.001' : payCard.totalToPay}
                                        displayType={'text'}
                                        decimalScale={2}
                                        FixedDecimalScale={true}
                                        thousandSeparator={true} prefix={'$'} renderText={value => <strong  className={`${styles?.bold} ${styles?.strongText}`}>{value} </strong>}
                                    />
                                }
                            </p>
                        </dt>
                    </dl>
            
                    <dl>
                        <dt>
                            <span className={styles?.numOption}>3</span> 
                            <p>Selecciona <span className={styles?.bold}>STP</span> en banco receptor y ¡listo!</p>
                        </dt>
                    </dl>
                    
                    <p className={`${styles?.textTP} ${styles?.textCenter}`}>Verás reflejado tu pago en máximo 48 horas.</p>
                </div>
                {isMobile === 'desktop'
                    ?
                        <PrintMeThanskPageSpei
                            clabe={clabe}
                            payCode={payCode}
                            payCard={payCard}
                        />
                    : null
                }
            </div>
        </div>
    )
}

export function PrintMeThanskPageSpei(props){
    const {
        payCard,
        clabe,
        concepto
    } = props

    const handleImprimir = () => {
        let printContents = document.getElementById("imprimir").innerHTML;
        let originalContents = document.body.innerHTML;
        window.print();
    };

    return(
        <>
            <div className={styles?.captureScreen} >
                <span>Captura esta pantalla o anota los datos</span>
            </div>
            <div id="imprimir" className={styles?.printme}>
                <div className='formasPagoTienda' id="contenedorImprimir">
                    <div className='logoCSprint'>
                        <img src="/credito-claroshop/img/newCredito/logo-claroshop.svg" alt="logoCS" />
                    </div>

                    <div className='marginTop15 marginBottom35'>
                        <h1 className='bold'>Pagar en SPEI crédito Claroshop</h1>
                    </div>

                    <div className='marginTop15'>
                        <p>Podras pagar tu crédito Claroshop desde la app o Banaca en linea del banco de tu preferencia</p>
                    </div>

                    <div className='marginTop15'>
                        <p>El pago debe ser en una sola exhibición y se verá reflejado en máximo 48 horas.</p>
                    </div>

                    <div className='marginTop15'>
                        <span>Los datos para hacer tu transferencia son:</span>
                    </div>

                    <div className='cardSpeiData'>
                        <dl>
                            <dt>Monto a pagar: </dt>
                            <dd>
                                {payCard &&
                                    <CurrencyFormat
                                        value={Number(payCard.totalToPay % 1) === 0 ? payCard.totalToPay + '.001' : payCard.totalToPay}
                                        displayType={'text'}
                                        decimalScale={2}
                                        FixedDecimalScale={true}
                                        thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                                    />
                                }
                            </dd>
                        </dl>
                        <dl>
                            <dt>CLABE: </dt>
                            <dd>{clabe}</dd>
                        </dl>
                        <dl>
                            <dt>Concepto: </dt>
                            <dd>{concepto}</dd>
                        </dl>
                        <dl>
                            <dt>Banco receptor: </dt>
                            <dd>STP</dd>
                        </dl>
                    </div>
                    <p className='marginTop10 marginBottom20'>Los datos aquí mostrados son para el uso exclusivo de esta compra, no son reutilizables para  pagos posteriores</p>
                    <div className='marginBottom20 divSpanPrint'>
                        <img src="/credito-claroshop/img/icon_captura_pantalla.svg"></img>
                        <span>Captura esta pantalla o anota los datos</span>
                    </div>
                </div>
            </div>
        </>
    )
}